import { createFileRoute, redirect } from '@tanstack/react-router';

// Вход в раздел ведет на книги; доступ проверяет layout-маршрут /curriculum
export const Route = createFileRoute('/curriculum/')({
  beforeLoad: () => {
    throw redirect({ to: '/curriculum/books', replace: true });
  },
});
